<app-button class="btn-back-menu" [icon]="'keyboard_backspace'" [content]="btn_backToMenu_content" (clickCusto)="btn_backToMenu_click()"></app-button>